module.exports = __webpack_public_path__ + "static/application-651fe702f8f4f4abe279aa5c797c0e6f.png";